import { CurrentUser } from 'customTypes'
import { UserEvents } from 'hooks/analytics'
import { transformIntoGoogleTagManagerUser } from 'utils/analytics'
import { useGoogleTagManagerTrack } from './useGoogleTagManagerTrack'

export const useGoogleTagManagerTrackSignUp = () => {
  const trackTagManager = useGoogleTagManagerTrack()

  const track = async (user: NonNullable<CurrentUser>) => {
    trackTagManager(UserEvents.Identify, await transformIntoGoogleTagManagerUser(user))
  }

  return track
}
